export default "__VITE_ASSET__CbpoKU32__"